import React, { Component } from 'react';
import { Title, Button, Error } from 'library';
import TilesSize from './TilesSize/TilesSize';
import styles from './styles';
import { css } from 'aphrodite';

class TilesSizes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isImperialSystem: props.isImperialSystem,
            isError: props.isError,
            isErrorFloorPart: props.isErrorFloorPart,
            isMultiple: false,
            tilesDimensions: [
                {
                    tilesWidth: "",
                    tilesHeight: "",
                    area: "",
                    isError: false
                }
            ],
            isButtonTileSizeActive: true,
        }
        this.maxTilesSizes = 5;
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.isImperialSystem !== this.props.isImperialSystem) {
            this.setState({isImperialSystem: this.props.isImperialSystem});
        }
        if(prevProps.isError !== this.props.isError) {
            this.setState({isError: this.props.isError});
        }
        if(prevProps.isErrorFloorPart !== this.props.isErrorFloorPart) {
            this.setState({isErrorFloorPart: this.props.isErrorFloorPart});
        }
    }

    addBlock(tileDimensions, index) {
        const {
            widthLabel,
            heightLabel,
            widthDescription,
            heightDescription,
            errorLabel,
            rowTitle,
            floorLabel,
            floorDescription,
            floorOperator,
            imageTile1,
            imageTile2,
            imgUrl,
            dataLayer,
        } = this.props;

        return(<TilesSize
            key={index}
            index={index}
            isImperialSystem={this.state.isImperialSystem}
            isMultiple={this.state.isMultiple}
            widthLabel={widthLabel}
            heightLabel={heightLabel}
            widthDescription={widthDescription}
            heightDescription={heightDescription}
            floorLabel={floorLabel}
            floorDescription={floorDescription}
            floorOperator={floorOperator}
            onClick={(e)=>this.handleDeleteTileButton(e, index)}
            rowTitle={rowTitle}
            link={"#"}
            errorLabel={errorLabel}
            isError={this.state.isError}
            isErrorFloorPart={this.state.isErrorFloorPart}
            dimensions={tileDimensions}
            onTilesDimensionsEntered={(dimensions)=>this.setDimensions(dimensions, index)}
            imageTile1={imageTile1}
            imageTile2={imageTile2}
            imgUrl={imgUrl}
            dataLayer={dataLayer}
        />)
    }

    setDimensions(dimensions, index) {
        this.setState(state => {
            const tilesDimensions = state.tilesDimensions.map((tileDimensions, tileIndex) => {
                return tileIndex === index ? dimensions : tileDimensions;
            })
            return {tilesDimensions};
        },()=>{
            this.checkIfReady();
        });
    }

    checkIfReady() {
        let isReady = true;
        if(this.state.tilesDimensions.length === 0) {
            isReady = false;
        } else if(this.state.tilesDimensions.length === 1) {
            if(this.state.tilesDimensions[0].tilesWidth === "" ||
                this.state.tilesDimensions[0].tilesHeight === "") {
                isReady = false;
            }
        } else {
            this.state.tilesDimensions.map((tm)=>{
                if(tm.tilesWidth === "" || tm.tilesHeight === "" || tm.area === "") {
                    isReady = false;
                }
                return false;
            });
        }
        isReady ?
            this.props.onTilesDimensionsEntered(this.state.tilesDimensions)
            :
            this.props.onTilesDimensionsEntered(null);
    }

    handleAddTileButton(e) {
        e.preventDefault();

        this.setState({
            isButtonTileSizeActive: this.state.tilesDimensions.length < this.maxTilesSizes-1,
            isMultiple: true,
            tilesDimensions: [...this.state.tilesDimensions, {
                tilesWidth: "",
                tilesHeight: "",
                area: "",
                isError: false
            }],
        }, ()=>{
            this.checkIfReady();
        })
    }

    handleDeleteTileButton(e, index) {
        e.preventDefault();

        this.setState({
            isButtonTileSizeActive: true,
            isMultiple: this.state.tilesDimensions.length > 2,
            tilesDimensions: this.state.tilesDimensions.filter((tile, tileIndex)=>tileIndex !== index)
        });

    }

    render() {
        const {
            title,
            paragraph,
            addTileSizeButtonLabel,
            errorBtnLabel,
            floorPartErrorLabel,
            inactiveButtonLabel,
            dataLayer,
            product,
            context,
        } = this.props;

        return (
            <div className={css(styles.tileSize)}>
                <div className={css(styles.wrapper)}>

                    <Title style={styles.h3}>{title}</Title>
                    {paragraph != null &&
                        <div className={css(styles.paragraph)} dangerouslySetInnerHTML={{__html: paragraph}}></div>
                    }

                    {this.state.tilesDimensions.map((ts, index)=>this.addBlock(ts, index))}

                    {this.state.isErrorFloorPart &&
                        <div className={css(styles.errorTop)}>
                            <Error label={floorPartErrorLabel}/>
                        </div>
                    }

                    <div className={css(styles.buttonWrapper)}>
                        <Button
                            text={addTileSizeButtonLabel}
                            onClick={(e)=>this.handleAddTileButton(e)}
                            isActive={this.state.isButtonTileSizeActive}
                            inactiveText={inactiveButtonLabel}
                            isTracked
                            trackingEventAction={'add another surface'}
                            typeOfGrout={product ? product.entity.entityLabel : 'no product selected'}
                            dataLayer={dataLayer}
                            context={context}
                        />
                    </div>

                    {!this.state.isButtonTileSizeActive &&
                    <div className={css(styles.error)}>
                        <Error label={errorBtnLabel}/>
                    </div>
                    }
                </div>

            </div>
        );
    }
}

export default TilesSizes;